<div class="login-screen" role="dialog" aria-modal="true" [attr.aria-label]="'login.dialog' | transloco">
  <header class="login-bar">
    <span class="brand-mark"><mat-icon>compare_arrows</mat-icon></span>
    <span class="brand-title">{{ 'brand.lead' | transloco }} <strong>{{ 'brand.mark' | transloco }}</strong></span>
    <div class="view-switch lang-switch login-lang" role="group" [attr.aria-label]="'toolbar.language' | transloco">
      @for (lang of langs; track lang) {
        <button type="button" [class.active]="activeLang() === lang" [attr.aria-pressed]="activeLang() === lang" (click)="setLang(lang)">{{ lang.toUpperCase() }}</button>
      }
    </div>
  </header>
  <div class="login-stage">
  @if (split()) {
  <div class="login-grid">
    @for (env of environments; track env.id) {
      <section class="login-card" [attr.aria-label]="env.label">
        <div class="eyebrow">{{ env.label }}</div>
        @if (account(env.id); as account) {
          <div class="login-loaded">
            <h2>{{ 'login.loaded' | transloco }}</h2>
            <p class="note">{{ 'login.loadedHint' | transloco:{ env: env.label } }}</p>
            @if (account.userName || account.email) {
              <p class="note">{{ account.userName || account.email }}</p>
            }
            <button class="login-logout" type="button" mat-stroked-button (click)="logout(env.id)">{{ 'login.logout' | transloco }}</button>
          </div>
        } @else {
          <h2>{{ 'login.title' | transloco }}</h2>
          <form class="login-form" (submit)="signIn(env.id, $event)">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'login.username' | transloco }}</mat-label>
              <input matInput autocomplete="username" [name]="'username-' + env.id" [ngModel]="session(env.id).username" (ngModelChange)="patch(env.id, { username: $event })" [disabled]="session(env.id).pending" required>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'login.password' | transloco }}</mat-label>
              <input matInput [type]="session(env.id).visible ? 'text' : 'password'" autocomplete="current-password" [name]="'password-' + env.id" [ngModel]="session(env.id).password" (ngModelChange)="patch(env.id, { password: $event })" [disabled]="session(env.id).pending" required>
              <button mat-icon-button matSuffix type="button" (click)="patch(env.id, { visible: !session(env.id).visible })" [disabled]="session(env.id).pending" [attr.aria-label]="(session(env.id).visible ? 'login.hidePassword' : 'login.showPassword') | transloco" [attr.aria-pressed]="session(env.id).visible">
                <mat-icon>{{ session(env.id).visible ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
            @if (session(env.id).error; as message) {
              <p class="login-error" role="alert">{{ message }}</p>
            }
            <button class="login-submit" type="submit" mat-flat-button color="primary" [disabled]="session(env.id).pending">{{ session(env.id).pending ? ('login.pending' | transloco) : ('login.submit' | transloco) }}</button>
          </form>
        }
      </section>
    }
  </div>
  } @else {
  <div class="login-single">
    <section class="login-card" [attr.aria-label]="'login.dialog' | transloco">
      <div class="eyebrow">{{ 'login.eyebrow' | transloco }}</div>
      <h2>{{ 'login.title' | transloco }}</h2>
      <p class="note">{{ 'login.singleHint' | transloco }}</p>
      <form class="login-form" (submit)="signInAll($event)">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'login.username' | transloco }}</mat-label>
          <input matInput autocomplete="username" name="username" [ngModel]="shared().username" (ngModelChange)="shared.update(form => ({ ...form, username: $event }))" [disabled]="shared().pending" required>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'login.password' | transloco }}</mat-label>
          <input matInput [type]="shared().visible ? 'text' : 'password'" autocomplete="current-password" name="password" [ngModel]="shared().password" (ngModelChange)="shared.update(form => ({ ...form, password: $event }))" [disabled]="shared().pending" required>
          <button mat-icon-button matSuffix type="button" (click)="shared.update(form => ({ ...form, visible: !form.visible }))" [disabled]="shared().pending" [attr.aria-label]="(shared().visible ? 'login.hidePassword' : 'login.showPassword') | transloco" [attr.aria-pressed]="shared().visible">
            <mat-icon>{{ shared().visible ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <button class="login-submit" type="submit" mat-flat-button color="primary" [disabled]="shared().pending">{{ shared().pending ? ('login.pending' | transloco) : ('login.submit' | transloco) }}</button>
      </form>
    </section>
  </div>
  }
  </div>
</div>
